export { default, type OrderedCardTemplateProps } from './OrderedCardTemplate';
